<div class="dtf-accountdetails">
  <div class="dtf-alertpage"></div>
  <br>
  <div class="container_dashboard" >
  <div class="cardlike">
  <h1 class="mercedes-me-login__column-headline2">Manage Banners</h1>
  <p class="paragraph1">Important: Please test all changes in the staging environment before applying them to production.Ensure you back up the existing content, as any updates will overwrite the current copy and cannot be undone.All changes are pushed to the website immediately.</p>
  <br> <br>
  </div>
  <br>
  <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
    <!--Spinner on Login Load-->
    <div class="demo-container">
      <span>{{ 'Invoice.Loading' | translate }}</span>
      <div class="progress-bar">
        <div class="progress-bar-value"></div>
      </div>
    </div>
    <br>
  </div>
  <mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

    <ng-container [matColumnDef]="column.name" *ngFor="let column of initColumns">
      
      <mat-header-cell mat-sort-header *matHeaderCellDef [attr.colspan]="column.colspan" style="justify-content: center;">
        {{ isFrench ? column.displayFR : column.display }}
      </mat-header-cell>

      <mat-cell *matCellDef="let element" style="justify-content: center;">
        <!-- Editable Input -->
        <div *ngIf="column.dispFormat === 'editable'" class="editable-field">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Edit Value</mat-label>
            <input matInput [(ngModel)]="element[column.name]" [value]="element[column.name]" />
          </mat-form-field>
        </div>
      
        <!-- Editable Textarea -->
        <div *ngIf="column.dispFormat === 'editablecopy'" class="editable-field">
          <mat-form-field appearance="outline" style="width: 110%; margin-top: 14px;">
            <mat-label>Edit Banner Copy</mat-label>
            <textarea matInput [(ngModel)]="element[column.name]" rows="3">
          </textarea>
          </mat-form-field>
        </div>
        <div *ngIf="column.dispFormat === ''">
          {{ element[column.name] }}
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="alerts">
      <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
        [attr.colspan]="displayedColumns.length">
      </mat-cell>
    </ng-container>
    <!-- ✅ REQUIRED -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
<!-- Save Button -->
<div style="margin-top: 20px;">
  <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
    <button class="mbfs-button" (click)="saveData()">Save</button>
    <div *ngIf="successMessage" class="success-banner">
      {{ successMessage }}
    </div>
  </div>
</div>
</div>